import uniqBy from 'utils/uniqBy';

import {
  getMaximumNumberOfPages,
  getMinimumNumberOfPages,
  getNumberOfPages,
} from 'editor-utils/template';

const pagesValidator = (template, pages = [], config = {}, printType = 'print') => {
  const errors = {
    warning: [],
    critical: [],
    confirmation: [],
  };

  const numberOfPages = getNumberOfPages(template, pages);
  const minimumNumberOfPages = getMinimumNumberOfPages(template);
  const maximumNumberOfPages = getMaximumNumberOfPages(template);

  if (numberOfPages < minimumNumberOfPages) {
    const minimum = template.cover ? minimumNumberOfPages - 1 : minimumNumberOfPages;
    errors.critical.push({
      text: `Your ${printType} has very few pages. The minimum is ${minimum} pages.`,
    });
  } else if (numberOfPages > maximumNumberOfPages) {
    const maximum = template.cover ? maximumNumberOfPages - 1 : maximumNumberOfPages;
    errors.critical.push({
      text: `Your ${printType} reached the maximum number of pages. The maximum is ${maximum} pages.`,
    });
  }

  return {
    config,

    isValid: (allowWarnings = false) => {
      if (errors.critical.length > 0) {
        return false;
      }

      if (!allowWarnings && errors.warning.length > 0) {
        return false;
      }

      if (!allowWarnings && errors.confirmation.length > 0) {
        return false;
      }

      return true;
    },

    error: (text, type = 'critical') => {
      errors[type].push({ text });
    },

    critical: text => {
      errors.critical.push({ text });
    },

    warning: text => {
      errors.warning.push({ text });
    },

    confirmation: text => {
      errors.confirmation.push({ text, checked: false });
    },

    getErrors: () => {
      return [
        ...uniqBy(errors.critical, 'text').map(item => ({ ...item, type: 'critical' })),
        ...uniqBy(errors.warning, 'text').map(item => ({ ...item, type: 'warning' })),
        ...uniqBy(errors.confirmation, 'text').map(item => ({ ...item, type: 'confirmation' })),
      ];
    },
  };
};

export default pagesValidator;
